import React, { useState } from "react";
import { EditIcon, CopyIcon } from "../../assets/Icons";
import { Link, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { handleCopy } from "../../utils";
import AddDirectory from "../../Modals/AddDirectory";
import NoDataFound from "../common/NoDataFound";

const DirectoryList = ({ list = [], loading }) => {
  const navigate = useNavigate();
  const [copyText, setCopyText] = useState("Copy");

  return (
    <>
      <div className="table-responsive machinelist workflowtb mt-2">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">SNo</th>
              <th>Directory Name</th>
              <th>Default Channel</th>
              <th className="text-center">Type</th>
              <th className="text-center">UUID</th>
              <th className="text-center">Token</th>
            </tr>
          </thead>
          <tbody>
            {list.length > 0 ? (
              list.map((item, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>
                  <td>
                    {" "}
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/dashboard/directories/info/${item.uuid}`)}
                    >
                      {item.name}
                    </p>{" "}
                  </td>
                  <td>{item?.defaultChannel?.name}</td>
                  <td className="text-center">{item.directoryType}</td>
                  <td className="text-center tokentd">
                    <Tooltip title={copyText}>
                      <span className="tokenText copyText" onClick={handleCopy(`${item?.uuid}`, setCopyText)}>
                        {item.uuid}
                      </span>
                    </Tooltip>
                  </td>
                  <td className="text-center tokentd">
                    <Tooltip title={copyText}>
                      <span className="tokenText copyText" onClick={handleCopy(`${item.token}`, setCopyText)}>
                        {item.token}
                      </span>
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted"></div>
                  {loading ? <NoDataFound text="Fetching Data..." /> : <NoDataFound text="No directories found" />}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DirectoryList;
